import type { FrontendWidget } from '../types';
import { RatingWidgetComponent } from './RatingWidgetComponent';
import { RatingWidgetComponentB } from './RatingWidgetComponentB';
import { RatingWidgetComponentC } from './RatingWidgetComponentC';
import type { RatingWidgetConfig, RatingWidgetResolved } from './types';

export const ratingWidget: FrontendWidget<
  RatingWidgetConfig,
  RatingWidgetResolved
> = {
  componentType: 'widgets.rating-widget',
  displayName: 'Rating Widget',
  ComponentA: RatingWidgetComponent,
  ComponentB: RatingWidgetComponentB,
  ComponentC: RatingWidgetComponentC,
  resolveSync: (config) => config,
};
